import React, { Component } from 'react';

import { Row, Col, Button, Popover, Card, Modal } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import LazyLoad from 'react-lazyload';

import {
     LoginOutlined,
     InstagramOutlined,
     MailOutlined,
} from '@ant-design/icons';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/OurCompanies/OurCompanies.css";

const messCard = {
     borderRadius: "20px",
     boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
}

const CompanyCard = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <div style={messCard}>
                    <Row>
                         <Col span={16} style={{ backgroundColor: "#f5f5f5", borderRadius: "20px 0 0 20px" }}>
                              <div >
                                   <p style={{ fontFamily: "IRANSans", color: "#8d8d8d", fontSize: ".85em", textAlign: "justify", direction: "rtl", lineHeight: "2em", padding: "20px" }}>
                                        {props.text}
                                   </p>
                              </div>
                         </Col>
                         <Col span={8} style={{ direction: "rtl", textAlign: "right", backgroundColor: "#fff", opacity: "90%", borderTopRightRadius: "20px", borderBottomRightRadius: "20px" }}>
                              <div style={{
                                   position: 'absolute', top: '50%',
                                   transform: 'translate(0%, -50%)'}}>
                                   <LazyLoad>
                                   <Center>
                                        
                                             <img
                                                  className="OurCompaniesLogos"
                                                  src={props.image}
                                             />
                                   </Center>
                                   </LazyLoad>
                                   <Margin top={3}></Margin>
                                   <Center>
                                        <strong style={{ fontFamily: "IranSans", fontSize: ".9em", color: "#174561", paddingRight: "10px" }}>
                                             {props.title}
                                        </strong>
                                   </Center>
                                   <Center>
                                        <p style={{ fontFamily: "IranSans", fontSize: ".8em", color: "#8d8d8d", paddingRight: "10px", marginTop: "5px", textAlign: "center" }}>
                                             {props.slogan}
                                        </p>
                                   </Center>
                                   <Row>
                                        <Col span={2}></Col>
                                        <Col span={20}>
                                             <hr style={{ border: ".1em solid #e13024", marginTop: "-10px" }} />
                                        </Col>
                                        <Col span={2}></Col>
                                   </Row>
                                   <div style={{ marginTop: "-5px" }}>
                                        <Center>
                                             <Popover content="ورود به سایت" placement="bottom">
                                                  <a href={props.site}><LoginOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#2867B2" }} /></a>
                                             </Popover>
                                             <Popover content={props.mail} placement="bottom">
                                                  <a><MailOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#4a00a0" }} /></a>
                                             </Popover>
                                             <a href={props.insta}><InstagramOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#E1306C" }} /></a>
                                        </Center>
                                   </div>
                              </div>
                         </Col>
                         <Margin bootom={3}></Margin>
                    </Row>
               </div>
          </div>
     ) : props.size === "tablet" ? (
          <div>
               <div style={messCard}>
                    <Row>
                         <Col span={16} style={{ backgroundColor: "#f5f5f5", borderRadius: "20px 0 0 20px" }}>
                              <div >
                                   <p style={{ fontFamily: "IRANSans", color: "#8d8d8d", fontSize: ".85em", textAlign: "justify", direction: "rtl", lineHeight: "2em", padding: "20px" }}>
                                        {props.text}
                                   </p>
                              </div>
                         </Col>
                         <Col span={8} style={{ direction: "rtl", textAlign: "right", backgroundColor: "#fff", opacity: "90%", borderTopRightRadius: "20px", borderBottomRightRadius: "20px" }}>
                              <div style={{
                                   position: 'absolute', top: '50%',
                                   transform: 'translate(0%, -50%)'}}>
                                        <LazyLoad>
                                   <Center>
                                             
                                        <img
                                             style={{ width: "60%", borderRadius: "50%", border: "1px solid #8d8d8d"  ,verticalAlign:"center"}}
                                             src={props.image}
                                        />
                                                 
                                   </Center>
                                        </LazyLoad>
                                   <Margin top={3}></Margin>
                                   <Center>
                                        <strong style={{ fontFamily: "IranSans", fontSize: ".95em", color: "#174561", paddingRight: "10px" }}>
                                             {props.title}
                                        </strong>
                                   </Center>
                                   <Center>
                                        <p style={{ fontFamily: "IranSans", fontSize: ".825em", color: "#8d8d8d", paddingRight: "10px", marginTop: "5px", textAlign: "center" }}>
                                             {props.slogan}
                                        </p>
                                   </Center>
                                   <Row>
                                        <Col span={2}></Col>
                                        <Col span={20}>
                                             <hr style={{ border: ".1em solid #e13024", marginTop: "-10px" }} />
                                        </Col>
                                        <Col span={2}></Col>
                                   </Row>
                                   <div style={{ marginTop: "-5px" }}>
                                        <Center>
                                             <Popover content="ورود به سایت" placement="bottom">
                                                  <a href={props.site}><LoginOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#2867B2" }} /></a>
                                             </Popover>
                                             <Popover content={props.mail} placement="bottom">
                                                  <a><MailOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#4a00a0" }} /></a>
                                             </Popover>
                                             <a><InstagramOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#E1306C" }} /></a>
                                        </Center>
                                   </div>
                              </div>
                         </Col>
                         <Margin bootom={3}></Margin>
                    </Row>
               </div>
          </div>

     ) : (
          <div>
               <div>
                <Row>
                    <Col span={1}></Col>
                    <Col span={22}>
                        <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                            <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                <Center>
                                    <Margin top={3}>
                                        <Center>
                                             <strong style={{ fontFamily: "IranSans", fontSize: ".8em", color: "#174561", paddingRight: "10px" }}>
                                                  {props.title}
                                             </strong>
                                        </Center>
                                        <Center>
                                             <p style={{ fontFamily: "IranSans", fontSize: ".7em", color: "#8d8d8d", paddingRight: "10px", marginTop: "5px", textAlign: "center" }}>
                                                  {props.slogan}
                                             </p>
                                        </Center>
                                    </Margin>
                                </Center>
                                <Center>
                                    <div className="cardTitleHR"></div>
                                </Center>
                                   
                                <Margin top={2}></Margin>
                                <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                   <p className="textParagraphMobile" style={{ paddingTop: "10px" }}>
                                        <Center>
                                             {props.text}
                                        </Center>   
                                   </p>
                                   <Popover content="ورود به سایت" placement="bottom">
                                        <a href={props.site}><LoginOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#2867B2" }} /></a>
                                   </Popover>
                                   <Popover content={props.mail} placement="bottom">
                                        <a><MailOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#4a00a0" }} /></a>
                                   </Popover>
                                   <a><InstagramOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#E1306C" }} /></a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={1}></Col>
                </Row>
            </div>
          </div>
          );
};

export default CompanyCard;
